import { Session } from './Session';
import { Vue } from 'vue-property-decorator';

export function routeHelper(vue: Vue, name: string, query: any = {}) {
  if (Session.isExist('USER')) {
    const building = Session.getSessionBuildingId();
    query.building = building;
  }
  vue.$router.push({ name: name, query: query });
}

export function routeHelperOpenNewTab(vue: Vue, name: string, query: any = {}) {
  if (Session.isExist('USER')) {
    const building = Session.getSessionBuildingId();
    query.building = building;
  }
  const routeData = vue.$router.resolve({ name: name, query: query });
  window.open(routeData.href, '_blank');
}
